import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { FiEdit3, FiEye, FiInfo, FiPlusCircle } from "react-icons/fi";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  getMedicalStatusClass,
  MD_STATUS,
  MEDICAL_PROGRESS_CHECK,
  medicalFilterFieldsAllMedical,
} from "./Constant";

import moment from "moment";

import {
  MEDICAL_STATUS_VIEW,
  MEDICAL_REPORT_STATUS,
  capitalLabel,
  MEDICAL_STATUS,
  MEDICAL_TYPE,
  MEDICAL_TYPE_OPTION,
  employeeFormLabel,
  medicalFilterFields,
  validateMedicalRowFilter,
} from "./Constant";

import {
  createMedical,
  downloadMedicalCertificate,
  getAllMedical,
  getMedicalList,
} from "app/_services/ehs/MedicalService";

import { TRAINEE_TYPE_OPTION } from "../TrainingManagement/CONSTANTS";
import { useContractorPerson, useEmployee } from "app/_helpers/hooks";
import { Validation } from "app/_helpers/validation/Validation";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { isUserMedicalOfficer, isUserMM } from "../IncidentManagement/Helper";

import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";

import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import { useDispatch, useSelector } from "react-redux";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import AddToBatchModalMedical from "./Component/AddToBatchModalMedical";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { downloadFileByExistURL, downloadFileByURL } from "app/_helpers/reactHelper";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import { useForm } from "app/_helpers/hooks";
import MedicalFilters from "./Component/MedicalFilters";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import MedicalFiltersAll from "./Component/MedicalFilterAll";
import { useLocation } from "react-router-dom";
import { generatedTypeObj } from "app/_pages/UserManagement/Employee/Constant";
import { FaHourglassEnd } from "react-icons/fa";
import { FcOvertime } from "react-icons/fc";

const initialFilter = { medicalStatus: "all", medicalResult: "all", medicalTestType: "" };

function ViewDoneMedicalData() {
  //get status state
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  const [initialTableListAll, setInitialTableListAll] = useState([]);

  const [tableVFLListAll, setTableVFLListAll] = useState([]);

  const [filter, setFilter] = useState(
    !filterStatus?.medicalFilter
      ? { ...initialFilter }
      : { ...filterStatus?.medicalFilter }
  );
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const dispatchFunction = useDispatch();

  //
  const onReset = () => setFilterForm({ formA: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "medicalAssigneeTypeView") {
        prev.assigneeName = "";
        prev.assigneeID = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const initialData = useCallback(async () => {
    const fetchData = async () => {
      try {
        let response2 = await getAllMedical();

        if (!response2?.data) {
          setLoading(false);
          return;
        }
        setInitialTableListAll(
          Array.isArray(response2?.data)
            ? response2?.data.map((data, index) => ({
                ...data,
                locationName: data?.ehsSite ? data?.ehsSite?.name : "",
                sid: index + 1,
              }))
            : []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    dispatchFunction(filterActionAdd({ medicalFilter: filter }));
  }, [dispatchFunction, filter]);

  const downloadPdf = async (certificateFile) => {
    downloadFileByExistURL(
      URL_CONFIG.IMG_URL + certificateFile,
      `medical-certificate-${new Date().toISOString()}.pdf`
    );

    // downloadFileByURL(
    //   URL_CONFIG.DEV_URL +
    //     "global-configuration/ehs-module/download-medical-certificate/" +
    //     id,
    //   `medical-certificate-${new Date().toISOString()}.pdf`
    // );
  };

  const columnsAllMedical = useMemo(() => {
    const columnsAllMedical = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      // {
      //   dataField: "medicalTestTypeView",
      //   text: "Exam",
      //   sort: true,
      // },
      {
        dataField: "medicalAssigneeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "assigneeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.assigneeName)}</div>;
        },
      },
      {
        dataField: "assigneeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },

      {
        dataField: "lastIMEDate",
        text: "IME Date",
        sort: true,
        formatter: (date, row) =>
          row?.lastIMEDate ? DDMMYYYYFormat(row?.lastIMEDate) : "NA",
      },
      {
        text: "IME Cert #",
        dataField: "imeCertificateNo",
        sort: true,
        formatter: (id, row) => {
          let isCertificate = false;
          let certificateFile = "";
          if (
            // row?.medicalTestType === MEDICAL_TYPE.ime &&
            row?.imeCertificateId &&
            row?.imeUpdatedBy === generatedTypeObj.manual
          ) {
            isCertificate = true;
            certificateFile = row?.imefile && row?.imefile?.document_name;
          }
          return (
            <div className="actionIconsGroup">
              <span>{row?.imeCertificateNo || "NA"}</span>
              {isCertificate && isUserMedicalOfficer() && (
                <CustomTooltip tooltip={"Certificate"}>
                  <span
                    onClick={() => downloadPdf(certificateFile)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              )}
            </div>
          );
        },
      },
      {
        dataField: "lastPMEDate",
        text: "Last PME",
        sort: true,
        formatter: (date, row) =>
          row?.lastPMEDate ? DDMMYYYYFormat(row?.lastPMEDate) : "NA",
      },
      {
        text: "PME Cert #",
        dataField: "pmeCertificateNo",
        sort: true,
        formatter: (id, row) => {
          let isCertificate = false;
          let certificateFile = "";
          if (
            // row?.medicalTestType === MEDICAL_TYPE.pme &&
            row?.pmeCertificateId &&
            row?.pmeUpdatedBy === generatedTypeObj.manual
          ) {
            isCertificate = true;
            certificateFile = row?.pmefile && row?.pmefile?.document_name;
          }
          return (
            <div className="actionIconsGroup">
              <span>{row?.pmeCertificateNo || "NA"}</span>
              {isCertificate && isUserMedicalOfficer() && (
                <CustomTooltip tooltip={"Certificate"}>
                  <span
                    onClick={() => downloadPdf(certificateFile)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              )}
            </div>
          );
        },
      },
      {
        dataField: "lastSMEDate",
        text: "Last SME",
        sort: true,
        formatter: (date, row) =>
          row?.lastSMEDate ? DDMMYYYYFormat(row?.lastSMEDate) : "NA",
      },
      {
        text: "SME Cert #",
        dataField: "smeCertificateNo",
        sort: true,
        formatter: (date, row) => row?.smeCertificateNo || "NA",
      },
      {
        dataField: "nextPMEDate",
        text: "Next PME",
        sort: true,
        width: "300px",
        formatter: (date, row) =>
          row?.nextPMEDate ? (
            <span className="icons dateWthIcn">
              <span>{DDMMYYYYFormat(row?.nextPMEDate)} </span>
              {moment().year() >= moment(row?.nextPMEDate).year() ? (
                <>
                  {MEDICAL_PROGRESS_CHECK?.includes(row?.pmeStatus) ? (
                    <FaHourglassEnd style={{ color: "#2bb0e5" }} />
                  ) : row?.pmeStatus === MEDICAL_STATUS.overDue ? (
                    <img
                      className="iconImg"
                      src="/assets/images/overDueImg.png"
                      alt="over-dueImg"
                    />
                  ) : (
                    // <FcOvertime size={24} />
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </span>
          ) : (
            <span className="icons dateWthIcn noDT">
              <span>NA</span>
              {/* {MEDICAL_PROGRESS_CHECK?.includes(row?.imeStatus) ? (
                <FaHourglassEnd style={{ color: "#2bb0e5" }} />
              ) : // ) : moment(row?.nextTrainingDueDate) < moment() ? (
              row?.imeStatus === MEDICAL_STATUS.overDue ? (
                <img
                  src="/assets/images/overDueImg.png"
                  alt="over-dueImg"
                  className="iconImg"
                />
              ) : (
                ""
              )} */}
            </span>
          ),
      },
      {
        dataField: "nextSMEDate",
        text: "Next SME",
        sort: true,
        formatter: (date, row) =>
          row?.nextSMEDate ? (
            <span className="icons dateWthIcn">
              <span>{DDMMYYYYFormat(row?.nextSMEDate)} </span>
              {moment().year() >= moment(row?.nextSMEDate).year() ? (
                <>
                  {MEDICAL_PROGRESS_CHECK?.includes(row?.smeStatus) ? (
                    <FaHourglassEnd style={{ color: "#2bb0e5" }} />
                  ) : row?.smeStatus === MEDICAL_STATUS.overDue ? (
                    <img
                      className="iconImg"
                      src="/assets/images/overDueImg.png"
                      alt="over-dueImg"
                    />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </span>
          ) : (
            <span className="icons dateWthIcn noDT">
              <span>NA</span>
              {/* {MEDICAL_PROGRESS_CHECK?.includes(row?.smeStatus) ? (
                <FaHourglassEnd style={{ color: "#2bb0e5" }} />
              ) : // ) : moment(row?.nextTrainingDueDate) < moment() ? (
              row?.smeStatus === MEDICAL_STATUS.overDue ? (
                <img
                  src="/assets/images/overDueImg.png"
                  alt="over-dueImg"
                  className="iconImg"
                />
              ) : (
                ""
              )} */}
            </span>
          ),
      },
    ];
    return columnsAllMedical;
  }, []);

  // ************Use Effect ***************

  useEffect(() => {
    initialData();
  }, [initialData]);

  useEffect(() => {
    setTableVFLListAll(
      initialTableListAll?.filter?.((obj) => {
        return validateMedicalRowFilter(obj, filterForm);
      })
    );
  }, [filterForm, initialTableListAll]);

  const tableToolbarBeforeViewAll = () =>
    showFilter && (
      <MedicalFiltersAll
        fields={medicalFilterFieldsAllMedical}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );
  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Personnel Health Management",
            path: "/health-safety-and-environment/medical",
          },
          { name: "View Medical Data" },
        ]}
        module={ACTIVE_MODULE.personnelHealthManagement}
      />
      <br />
      <br />
      <div className="healthSafetyEnvironmentWrapper">
        <div>
          <div className="card p-4 mb-4 overflow-visible">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">{"View Medical Data"}</h3>
              <FilterBtn setShowFilter={setShowFilter} />

              <BackBtn url={`/health-safety-and-environment/medical`} />
            </div>

            <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
              <div className="hseMenuLinks card">
                {
                  <Link
                    to={"/health-safety-and-environment/medical/view-medical-data"}
                    className={`pointer${
                      location?.pathname.split("/")?.includes("view-medical-data")
                        ? " active"
                        : ""
                    }`}
                  >
                    Medical Data - Workflow Generated
                  </Link>
                }

                {
                  <Link
                    to={"/health-safety-and-environment/medical/view-done-medical-data"}
                    className={`pointer${
                      location?.pathname.split("/")?.includes("view-done-medical-data")
                        ? " active"
                        : ""
                    }`}
                  >
                    Medical Data - All
                  </Link>
                }
              </div>
            </div>

            {!loading ? (
              <SearchBootstrapTable
                searchKey={"ViewMedicalDataDesktopSearch"}
                data={tableVFLListAll.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                columns={columnsAllMedical}
                tableBeforeSearch={tableToolbarBeforeViewAll}
                tableKey="ViewMedicalData"
              />
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewDoneMedicalData;
